/**
 * Sempirical — frontend runtime configuration.
 *
 * ONE PLACE FOR THE API HOST. That is the entire point of this file.
 *
 * WHY IT EXISTS (2026-08-17)
 * --------------------------
 * The API base URL was written out in NINETEEN files, each as its own copy of
 *
 *     import.meta.env.VITE_API_URL || 'https://xlr8-platform-production.up.railway.app'
 *
 * When the Railway public domain changed to `sempirical-production`, that was
 * nineteen separate places to remember — and the failure mode is silent: if
 * VITE_API_URL is unset at BUILD time, every one of them falls back to a host
 * that no longer answers, the app loads fine, and every request fails.
 *
 * A hardcoded hostname repeated nineteen times is not a fallback, it is a
 * hand-maintained list. Those rot (CLAUDE.md: DERIVE, NEVER RECITE), and this
 * one rotted the first time it was tested.
 *
 * VITE BAKES THIS IN AT BUILD TIME, NOT RUN TIME. `import.meta.env` is
 * substituted by the bundler, so changing VITE_API_URL in Vercel does nothing
 * until the project is REDEPLOYED. Setting the variable is half the fix.
 *
 * THE FALLBACK IS A SAFETY NET, NOT THE CONFIGURATION. Set VITE_API_URL in
 * Vercel. The literal below exists so a local `npm run dev` works without a
 * .env file, and so a missing variable degrades to "points at prod" rather than
 * "points at undefined".
 */

export const API_BASE =
  import.meta.env.VITE_API_URL || 'https://sempirical-production.up.railway.app'

export default API_BASE
